import React, { useMemo } from 'react';
import { LicenseTypeEnum } from '../../core/domainModels/licences/LicenseType';
import { Item } from 'tacho-ui';
import { useIntl } from 'react-intl';

const useLicenseTypesOptions = (): Array<Item> => {
    const { formatMessage } = useIntl();

    return useMemo(
        (): Array<Item> => [
            { id: LicenseTypeEnum.Commercial, label: formatMessage({ id: LicenseTypeEnum.Commercial }) },
            { id: LicenseTypeEnum.Developer, label: formatMessage({ id: LicenseTypeEnum.Developer }) },
            { id: LicenseTypeEnum.Distributor, label: formatMessage({ id: LicenseTypeEnum.Distributor }) },
            { id: LicenseTypeEnum.Testing, label: formatMessage({ id: LicenseTypeEnum.Testing }) },
            { id: LicenseTypeEnum.Modular, label: formatMessage({ id: LicenseTypeEnum.Modular }) },
        ],
        [formatMessage],
    );
};

export default useLicenseTypesOptions;
